import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navbar
      "catalog": "Catalog",
      "login": "Login",
      "register": "Register",
      "orders": "Orders",
      "admin": "Admin",
      "logout": "Logout",
      
      // Home Page
      "home.title": "Your Health, Our Priority",
      "home.subtitle": "Order medicines online with ease. Fast delivery, genuine products, and expert care.",
      "home.browse": "Browse Medicines",
      "home.getStarted": "Get Started",
      "home.feature1.title": "Genuine Products",
      "home.feature1.desc": "100% authentic medicines from licensed suppliers",
      "home.feature2.title": "Easy Ordering",
      "home.feature2.desc": "Simple checkout process with multiple payment options",
      "home.feature3.title": "Expert Care",
      "home.feature3.desc": "Professional support and prescription management",
      
      // Auth
      "auth.welcomeBack": "Welcome Back",
      "auth.createAccount": "Create Account",
      "auth.email": "Email",
      "auth.password": "Password",
      "auth.fullName": "Full Name",
      "auth.phone": "Phone Number",
      "auth.whatsapp": "WhatsApp Number",
      "auth.whatsappSameAsPhone": "WhatsApp same as phone number",
      "auth.loginBtn": "Login",
      "auth.registerBtn": "Register",
      "auth.noAccount": "Don't have an account?",
      "auth.hasAccount": "Already have an account?",
      "auth.loginSuccess": "Login successful!",
      "auth.registerSuccess": "Registration successful!",
      "auth.loginFailed": "Login failed",
      "auth.registerFailed": "Registration failed",
      
      // Catalog
      "catalog.title": "Medicine Catalog",
      "catalog.search": "Search medicines...",
      "catalog.allCategories": "All Categories",
      "catalog.rxRequired": "Rx Required",
      "catalog.addToCart": "Add to Cart",
      "catalog.addedToCart": "Added to cart!",
      "catalog.loginRequired": "Please login to add items to cart",
      "catalog.loadFailed": "Failed to load medicines",
      "catalog.searchByName": "Search by Name",
      "catalog.searchBySymptom": "Search by Symptom",
      "catalog.symptomPlaceholder": "Describe your symptom (e.g., fever, headache, cough...)",
      "catalog.medicinesFor": "medicines found for",
      "catalog.commonSymptoms": "Common symptoms",
      "catalog.noResults": "No medicines found",
      "catalog.moreFilters": "More Filters",
      "catalog.pharmaceuticalForm": "Pharmaceutical Form",
      "catalog.ageGroup": "Age Group",
      "catalog.allForms": "All Forms",
      "catalog.allAgeGroups": "All Age Groups",
      "catalog.adult": "Adult",
      "catalog.child": "Child",
      "catalog.all": "All",
      "catalog.forChildren": "For Children",
      "catalog.forAdults": "For Adults",
      "catalog.clearFilters": "Clear Filters",
      
      // Cart
      "cart.title": "Shopping Cart",
      "cart.empty": "Your cart is empty",
      "cart.continueShopping": "Continue Shopping",
      "cart.quantity": "Quantity",
      "cart.total": "Total",
      "cart.checkoutMock": "Checkout with Mock Payment",
      "cart.checkoutStripe": "Checkout with Stripe",
      "cart.itemRemoved": "Item removed",
      "cart.removeFailed": "Failed to remove item",
      "cart.loadFailed": "Failed to load cart",
      "cart.differentBuyer": "The buyer is different from me",
      "cart.buyerInfo": "Buyer Information",
      "cart.buyerName": "Buyer's Full Name",
      "cart.buyerNamePlaceholder": "Enter buyer's full name",
      "cart.buyerPhone": "Buyer's Phone",
      "cart.buyerWhatsapp": "Buyer's WhatsApp",
      "cart.whatsappSameAsPhone": "WhatsApp same as phone",
      "cart.buyerNameRequired": "Please enter buyer's name",
      "cart.buyerPhoneRequired": "Please enter buyer's phone",
      
      // Checkout
      "checkout.title": "Checkout",
      "checkout.orderSummary": "Order Summary",
      "checkout.completePayment": "Complete Payment",
      "checkout.payNow": "Pay Now",
      "checkout.paymentSuccess": "Payment Successful!",
      "checkout.orderConfirmed": "Your order has been confirmed.",
      "checkout.viewOrders": "View Orders",
      "checkout.loading": "Loading order...",
      "checkout.paymentFailed": "Payment failed",
      
      // Orders
      "orders.title": "My Orders",
      "orders.noOrders": "No orders yet",
      "orders.orderId": "Order ID",
      "orders.loadFailed": "Failed to load orders",
      
      // Admin
      "admin.title": "Admin Dashboard",
      "admin.totalOrders": "Total Orders",
      "admin.totalUsers": "Total Users",
      "admin.totalMedicines": "Total Medicines",
      "admin.totalRevenue": "Total Revenue",
      "admin.recentOrders": "Recent Orders",
      "admin.user": "User",
      "admin.payment": "Payment",
      "admin.status": "Status",
      "admin.loadStatsFailed": "Failed to load stats",
      "admin.loadOrdersFailed": "Failed to load orders",
      
      // Payment Status
      "payment.pending": "pending",
      "payment.paid": "paid",
      "payment.processing": "processing",
      
      // Prescription Upload
      "prescription.title": "Upload Prescription",
      "prescription.required": "Prescription Required",
      "prescription.message": "This order contains prescription medicines. Please upload your prescription to proceed.",
      "prescription.dragDrop": "Drag and drop your prescription here, or click to select",
      "prescription.fileTypes": "Supported: JPG, PNG, PDF (Max 5MB)",
      "prescription.uploading": "Uploading...",
      "prescription.uploaded": "Prescription uploaded successfully!",
      "prescription.uploadFailed": "Failed to upload prescription",
      "prescription.viewPrescription": "View Prescription",
      "prescription.change": "Change File",
      "prescription.uploadBtn": "Upload Prescription",
      
      // Admin Management
      "admin.manageMedicines": "Manage Medicines",
      "admin.manageUsers": "Manage Users",
      "admin.addMedicine": "Add New Medicine",
      "admin.editMedicine": "Edit Medicine",
      "admin.deleteMedicine": "Delete Medicine",
      "admin.medicineName": "Medicine Name",
      "admin.description": "Description",
      "admin.price": "Price",
      "admin.category": "Category",
      "admin.brand": "Brand",
      "admin.stock": "Stock Quantity",
      "admin.imageUrl": "Image URL",
      "admin.requiresPrescription": "Requires Prescription",
      "admin.save": "Save",
      "admin.cancel": "Cancel",
      "admin.edit": "Edit",
      "admin.delete": "Delete",
      "admin.actions": "Actions",
      "admin.role": "Role",
      "admin.grantAdmin": "Grant Admin",
      "admin.revokeAdmin": "Revoke Admin",
      "admin.deleteUser": "Delete User",
      "admin.confirmDelete": "Are you sure you want to delete this?",
      "admin.medicineAdded": "Medicine added successfully!",
      "admin.medicineUpdated": "Medicine updated successfully!",
      "admin.medicineDeleted": "Medicine deleted successfully!",
      "admin.userRoleUpdated": "User role updated successfully!",
      "admin.userDeleted": "User deleted successfully!",
      "admin.date": "Date",
      "admin.prescriptionStatus": "Prescription"
    }
  },
  fr: {
    translation: {
      // Navbar
      "catalog": "Catalogue",
      "login": "Connexion",
      "register": "S'inscrire",
      "orders": "Commandes",
      "admin": "Admin",
      "logout": "Déconnexion",
      
      // Home Page
      "home.title": "Votre Santé, Notre Priorité",
      "home.subtitle": "Commandez des médicaments en ligne facilement. Livraison rapide, produits authentiques et soins experts.",
      "home.browse": "Parcourir les Médicaments",
      "home.getStarted": "Commencer",
      "home.feature1.title": "Produits Authentiques",
      "home.feature1.desc": "100% de médicaments authentiques de fournisseurs agréés",
      "home.feature2.title": "Commande Facile",
      "home.feature2.desc": "Processus de paiement simple avec plusieurs options",
      "home.feature3.title": "Soins Experts",
      "home.feature3.desc": "Support professionnel et gestion des ordonnances",
      
      // Auth
      "auth.welcomeBack": "Bon Retour",
      "auth.createAccount": "Créer un Compte",
      "auth.email": "E-mail",
      "auth.password": "Mot de passe",
      "auth.fullName": "Nom Complet",
      "auth.phone": "Numéro de Téléphone",
      "auth.whatsapp": "Numéro WhatsApp",
      "auth.whatsappSameAsPhone": "WhatsApp identique au téléphone",
      "auth.loginBtn": "Connexion",
      "auth.registerBtn": "S'inscrire",
      "auth.noAccount": "Vous n'avez pas de compte?",
      "auth.hasAccount": "Vous avez déjà un compte?",
      "auth.loginSuccess": "Connexion réussie!",
      "auth.registerSuccess": "Inscription réussie!",
      "auth.loginFailed": "Échec de la connexion",
      "auth.registerFailed": "Échec de l'inscription",
      
      // Catalog
      "catalog.title": "Catalogue de Médicaments",
      "catalog.search": "Rechercher des médicaments...",
      "catalog.allCategories": "Toutes les Catégories",
      "catalog.rxRequired": "Ordonnance Requise",
      "catalog.addToCart": "Ajouter au Panier",
      "catalog.addedToCart": "Ajouté au panier!",
      "catalog.loginRequired": "Veuillez vous connecter pour ajouter des articles au panier",
      "catalog.loadFailed": "Échec du chargement des médicaments",
      "catalog.searchByName": "Recherche par Nom",
      "catalog.searchBySymptom": "Recherche par Symptôme",
      "catalog.symptomPlaceholder": "Décrivez votre symptôme (ex: fièvre, mal de tête, toux...)",
      "catalog.medicinesFor": "médicaments trouvés pour",
      "catalog.commonSymptoms": "Symptômes courants",
      "catalog.noResults": "Aucun médicament trouvé",
      "catalog.moreFilters": "Plus de Filtres",
      "catalog.pharmaceuticalForm": "Forme Galénique",
      "catalog.ageGroup": "Groupe d'Âge",
      "catalog.allForms": "Toutes les Formes",
      "catalog.allAgeGroups": "Tous les Âges",
      "catalog.adult": "Adulte",
      "catalog.child": "Enfant",
      "catalog.all": "Tous",
      "catalog.forChildren": "Pour Enfants",
      "catalog.forAdults": "Pour Adultes",
      "catalog.clearFilters": "Effacer les Filtres",
      
      // Cart
      "cart.title": "Panier d'Achats",
      "cart.empty": "Votre panier est vide",
      "cart.continueShopping": "Continuer vos Achats",
      "cart.quantity": "Quantité",
      "cart.total": "Total",
      "cart.checkoutMock": "Payer avec Paiement Fictif",
      "cart.checkoutStripe": "Payer avec Stripe",
      "cart.itemRemoved": "Article supprimé",
      "cart.removeFailed": "Échec de la suppression de l'article",
      "cart.loadFailed": "Échec du chargement du panier",
      "cart.differentBuyer": "L'acheteur est différent de moi",
      "cart.buyerInfo": "Informations de l'Acheteur",
      "cart.buyerName": "Nom Complet de l'Acheteur",
      "cart.buyerNamePlaceholder": "Entrez le nom complet de l'acheteur",
      "cart.buyerPhone": "Téléphone de l'Acheteur",
      "cart.buyerWhatsapp": "WhatsApp de l'Acheteur",
      "cart.whatsappSameAsPhone": "WhatsApp identique au téléphone",
      "cart.buyerNameRequired": "Veuillez entrer le nom de l'acheteur",
      "cart.buyerPhoneRequired": "Veuillez entrer le téléphone de l'acheteur",
      
      // Checkout
      "checkout.title": "Paiement",
      "checkout.orderSummary": "Résumé de la Commande",
      "checkout.completePayment": "Finaliser le Paiement",
      "checkout.payNow": "Payer Maintenant",
      "checkout.paymentSuccess": "Paiement Réussi!",
      "checkout.orderConfirmed": "Votre commande a été confirmée.",
      "checkout.viewOrders": "Voir les Commandes",
      "checkout.loading": "Chargement de la commande...",
      "checkout.paymentFailed": "Échec du paiement",
      
      // Orders
      "orders.title": "Mes Commandes",
      "orders.noOrders": "Aucune commande pour le moment",
      "orders.orderId": "ID de Commande",
      "orders.loadFailed": "Échec du chargement des commandes",
      
      // Admin
      "admin.title": "Tableau de Bord Admin",
      "admin.totalOrders": "Total Commandes",
      "admin.totalUsers": "Total Utilisateurs",
      "admin.totalMedicines": "Total Médicaments",
      "admin.totalRevenue": "Revenu Total",
      "admin.recentOrders": "Commandes Récentes",
      "admin.user": "Utilisateur",
      "admin.payment": "Paiement",
      "admin.status": "Statut",
      "admin.loadStatsFailed": "Échec du chargement des statistiques",
      "admin.loadOrdersFailed": "Échec du chargement des commandes",
      
      // Payment Status
      "payment.pending": "en attente",
      "payment.paid": "payé",
      "payment.processing": "en traitement",
      
      // Prescription Upload
      "prescription.title": "Télécharger l'Ordonnance",
      "prescription.required": "Ordonnance Requise",
      "prescription.message": "Cette commande contient des médicaments sur ordonnance. Veuillez télécharger votre ordonnance pour continuer.",
      "prescription.dragDrop": "Glissez-déposez votre ordonnance ici, ou cliquez pour sélectionner",
      "prescription.fileTypes": "Formats supportés: JPG, PNG, PDF (Max 5Mo)",
      "prescription.uploading": "Téléchargement en cours...",
      "prescription.uploaded": "Ordonnance téléchargée avec succès!",
      "prescription.uploadFailed": "Échec du téléchargement de l'ordonnance",
      "prescription.viewPrescription": "Voir l'Ordonnance",
      "prescription.change": "Changer de Fichier",
      "prescription.uploadBtn": "Télécharger l'Ordonnance",
      
      // Admin Management
      "admin.manageMedicines": "Gérer les Médicaments",
      "admin.manageUsers": "Gérer les Utilisateurs",
      "admin.addMedicine": "Ajouter un Médicament",
      "admin.editMedicine": "Modifier le Médicament",
      "admin.deleteMedicine": "Supprimer le Médicament",
      "admin.medicineName": "Nom du Médicament",
      "admin.description": "Description",
      "admin.price": "Prix",
      "admin.category": "Catégorie",
      "admin.brand": "Marque",
      "admin.stock": "Quantité en Stock",
      "admin.imageUrl": "URL de l'Image",
      "admin.requiresPrescription": "Nécessite une Ordonnance",
      "admin.save": "Enregistrer",
      "admin.cancel": "Annuler",
      "admin.edit": "Modifier",
      "admin.delete": "Supprimer",
      "admin.actions": "Actions",
      "admin.role": "Rôle",
      "admin.grantAdmin": "Accorder Admin",
      "admin.revokeAdmin": "Révoquer Admin",
      "admin.deleteUser": "Supprimer l'Utilisateur",
      "admin.confirmDelete": "Êtes-vous sûr de vouloir supprimer ceci?",
      "admin.medicineAdded": "Médicament ajouté avec succès!",
      "admin.medicineUpdated": "Médicament mis à jour avec succès!",
      "admin.medicineDeleted": "Médicament supprimé avec succès!",
      "admin.userRoleUpdated": "Rôle utilisateur mis à jour avec succès!",
      "admin.userDeleted": "Utilisateur supprimé avec succès!",
      "admin.date": "Date",
      "admin.prescriptionStatus": "Ordonnance"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    lng: 'fr', // Set French as default
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;